import { render, staticRenderFns } from "./CotacaoDetalhes.vue?vue&type=template&id=2d91e4bf"
import script from "./CotacaoDetalhes.vue?vue&type=script&lang=js"
export * from "./CotacaoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports